export class PassWrapper {
  pass: string;
  token: string;
}
